// extracted by mini-css-extract-plugin
module.exports = {"divider":"outrights__divider___2m01l"};